module.exports = __webpack_public_path__ + "static/media/bg_log.9f877097.webp";